import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import B2BTheme from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { whyDidYouRender } from '../wdyr.jsx';
import { App } from './App';
import { getRoutes, getServerPages } from './routes.js';

NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext();
  client.setExperienceRoutes(getRoutes());

  const serverPages = await getServerPages();

  if (client.customer.type === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  }

  const customerType =
    client.customer.type || window.THDCustomer?.default?.customerType || '';

  const customerRole =
    client.customer.role || window.THDCustomer?.default.role || '';

  client.render(
    <App
      customerType={customerType.toUpperCase()}
      customerRole={customerRole.toUpperCase()}
      serverPages={serverPages}
    />,
  );
});
